import React, { FC } from 'react';

import { DebtClass } from '../../../api-client';
import { cn } from '../../../utils';
import ProjectCategory from '../ProjectCategory';
import styles from './ProjectDebtClass.module.scss';

interface Props {
  debtClass: DebtClass;
  className?: string;
}

const ProjectDebtClass: FC<Props> = ({ debtClass, className }) => (
  <ProjectCategory
    debtClass={debtClass}
    delimiter="/"
    title="Класс долга"
    className={cn(styles.debtClass, className)}
  />
);

export default ProjectDebtClass;
